export function formatDate(dateString, isHour = false, locate = "pt-BR") {
  if (!dateString) return "";
  const date = new Date(dateString);
  if (isHour) {
    return date.toLocaleDateString(locate, {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      timeZone: "America/Sao_Paulo",
    });
  }
  return date.toLocaleDateString(locate, {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });
}

export function isDateExpired(dateEnd) {
  if (!dateEnd) return false;
  const endDate = new Date(dateEnd);
  const today = new Date();
  return endDate < today;
}

// Helper para parsear datas no formato YYYY-MM-DD mantendo o timezone local
export function parseLocalDate(dateString) {
  if (!dateString) return null;
  const [year, month, day] = dateString.split('-').map(Number);
  return new Date(year, month - 1, day);
}